export const NEW_PASSOWRD_REQUEST = 'NEW_PASSOWRD_REQUEST';
export const NEW_PASSOWRD_SUCCESS = 'NEW_PASSOWRD_SUCCESS';
export const NEW_PASSOWRD_FAILURE = 'NEW_PASSOWRD_FAILURE';
